enum SnapchatEventConversionType {
    OFFLINE = 'OFFLINE',
    WEB = 'WEB',
    MOBILE_APP = 'MOBILE_APP'
}

export default SnapchatEventConversionType;
